import React from "react";
import { defineMessages, FormattedDate } from "react-intl";
import ApiMessage from "assets/scripts/components/presentational/ApiMessage/ApiMessage";
import Pagination from "assets/scripts/components/presentational/Pagination/Pagination";
import Table from "assets/scripts/components/presentational/Table/Table";
const headers = defineMessages({
    type: {
        id: "documents.documentTable.header.type",
        defaultMessage: "Type"
    },
    name: {
        id: "documents.documentTable.header.name",
        defaultMessage: "Name"
    },
    date: {
        id: "documents.documentTable.header.date",
        defaultMessage: "Date"
    }
});
const DocumentTable = ({ documents, documentTypes }) => {
    const columns = [];
    columns.push({
        header: headers.type,
        value: it => <ApiMessage value={documentTypes[it.documentTypeId]?.name || ""} valueES={documentTypes[it.documentTypeId]?.nameES || ""}/>
    }, {
        header: headers.name,
        value: it => <a href={it.url} className="link">
					{it.fileName}
				</a>
    }, {
        header: headers.date,
        value: it => <FormattedDate value={it.timestamp.toDate()} month="short" day="numeric" year="numeric" hour={it.documentTypeId === 8 ? undefined : "numeric"} minute={it.documentTypeId === 8 ? undefined : "numeric"}/>
    });
    return (<Pagination items={documents} itemsPerPage={10}>
			{({ page, renderPager, pageIndex }) => (<div>
					<Table items={page} columns={columns} srLabel={"Document"} srLabelPlural={"Documents"} pageIndex={pageIndex} itemsPerPage={10} getKey={it => it.url}/>
					{renderPager("Document")}
				</div>)}
		</Pagination>);
};
export default DocumentTable;



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/secure/Documents/DocumentTable/DocumentTable.tsx